import React, { SyntheticEvent } from 'react'
import AutocompleteField from '../fields/AutocompleteField'
import { FormElementProps } from './FormElementParts'

const AutocompleteElement: React.FC<FormElementProps> = ({
  label,
  multiSelect,
  name,
  onChange,
  options,
  value,
}) => {
  const acOpts = options?.map(({ label, value }) => ({ label, value })) || []
  const acVal = Array.isArray(value)
    ? value.map((v) => ({ label: v, value: v }))
    : []

  const handleChange = (evt: SyntheticEvent, value) => {
    evt.preventDefault()

    const theValue = (value || []).map((valShape) => valShape.value)
    onChange?.({ name, value: theValue })
  }

  return (
    <AutocompleteField
      id={name}
      label={label}
      multiple={multiSelect}
      name={name}
      onChange={handleChange}
      options={acOpts}
      value={acVal}
    />
  )
}

export default AutocompleteElement
